// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB42V9IJlSgsjWDsug41rdRc11XH6Wss1w",
  authDomain: "workouttracker-9d7ec.firebaseapp.com",
  projectId: "workouttracker-9d7ec",
  storageBucket: "workouttracker-9d7ec.firebasestorage.app",
  messagingSenderId: "230681175035",
  appId: "1:230681175035:web:c8ac4fc8df48644fa3a15e",
  measurementId: "G-V9Z3BRQ3R8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db };
